import { getCountries } from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { Select } from "antd";
import _orderBy from "lodash/orderBy";

const { Option } = Select;
let countries = [];

getCountries().forEach((country) => {
  let obj = {};
  if (country === "US") {
    obj["id"] = country;
    obj["name"] = en[country] + " (US)";
    obj["label"] = en[country] + " USA";
    countries.push(obj);
  } else if (country === "GB") {
    obj["id"] = country;
    obj["name"] = en[country] + " (UK)";
    obj["label"] = en[country] + " (UK)";
    countries.push(obj);
  } else if (
    country !== "CU" &&
    country !== "IR" &&
    country !== "KP" &&
    country !== "SD" &&
    country !== "SY" &&
    country !== "PK" &&
    country !== "SO" &&
    country !== "SS" 
  ) {
    obj["id"] = country;
    obj["name"] = en[country];
    obj["label"] = en[country];
    countries.push(obj);
  }
});

let sortedCountryList = _orderBy(countries, ["name"], ["asc"]) || [];

export const countryList = sortedCountryList.map((country) => {
  let { id = "", name = "", label = "" } = country;
  if(id === 'SA') {
    return null;
  }else{
    return (
    <Option key={id} value={name} label={label}>
      {name}
    </Option>
    )
  }
});

export const countryListRegister = sortedCountryList.map((country) => {
  let { id = "", name = "", label = "" } = country;
  return (
    <Option key={id} value={name} label={label}>
      {name}
    </Option>
  )
});
